/* eslint-disable eqeqeq */
import * as React from "react";
import Box from "@mui/material/Box";
import { Formik } from "formik";
import Styles from "./Update.module.scss";
import { useDispatch } from "react-redux";
import { Form } from "react-bootstrap";
import { updateTicket } from "../../redux/admin/actions/admin.actions";

export default function CloseTicket(props) {
  const dispatch = useDispatch();

  return (
    <>
      <Formik
        initialValues={{
          resolve: "",
          ticket_id: props.id,
        }}
        validate={(values) => {
          const errors = {};
          if (!values.resolve) {
            errors.resolve = "This field is required";
          }

          return errors;
        }}
        onSubmit={(values) => {
          dispatch(updateTicket(values));
          props.onClickYes();
          // console.log(values);
        }}
      >
        {({
          handleChange,
          handleSubmit,
          isSubmitting,
          values,
          event,
          resetForm,
          setFieldValue,
          handleBlur,
          errors,
          touched,
        }) => (
          <>
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, minWidth: "50ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <>
                <div className="d-flex flex-column mb-2">
                  <p className={Styles.label}>Message</p>
                </div>
                <div>
                  <Form.Control
                    as="textarea"
                    onChange={handleChange}
                    name="resolve"
                    placeholder="Reason for closing this ticket"
                    // style={{ height: "100px" }}
                  />
                </div>
                {errors.resolve && touched.resolve ? (
                  <p className="text-danger mt-1 mx-2">{errors.resolve}</p>
                ) : null}
              </>

              <div className="d-flex justify-content-center mt-3">
                <button
                  type="submit"
                  className={` shadow-none ${Styles.actionBtn} ${Styles.confirm} `}
                  style={{ background: props.btnColor }}
                  onClick={() => props.onClickNo()}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className={` shadow-none  ${Styles.actionBtn} ${Styles.reject}`}
                  style={{ background: props.btnColor }}
                  onClick={handleSubmit}
                >
                  Update
                </button>
              </div>
            </Box>
          </>
        )}
      </Formik>
    </>
  );
}
